module.exports = __webpack_public_path__ + "static/img/conveyor-belt-mk-2_256.5cb28a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-belt-mk-2_256.png
// module id = yTsg
// module chunks = 0